import { ContractKeyGroup } from '@cube3/common/model/schema/resources/contract-key-group';
import { isNotEmpty } from '@cube3/common/utils/isEmpty';

export const hasDefaultValue = (keyGroup: ContractKeyGroup) => {
  if (!keyGroup) return false;
  return !!keyGroup.keys.find((key) =>
    isNotEmpty(JSON.parse(key.json_schema).default)
  );
};
